// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2aft0","col":"styles_col__3xuwS","actions":"styles_actions__kb7Xi","conflict":"styles_conflict__JGuGW"};